var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewTenantList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 454,
    viewBox: "0 0 280 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1224_6680)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 454,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 32.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 32.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 37,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 50,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 60,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 32.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 32.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 37,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 50,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 60,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 92.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 92.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 97,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 110,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 120,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 92.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 92.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 97,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 110,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 120,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 152.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 152.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 157,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 170,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 180,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 152.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 152.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 157,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 170,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 180,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 212.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 212.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 217,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 230,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 240,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 212.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 212.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 217,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 230,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 240,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 272.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 272.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 277,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 290,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 300,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 272.5,
    width: 123,
    height: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 272.5,
    width: 123,
    height: 49,
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 277,
    width: 40,
    height: 40,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 290,
    width: 30,
    height: 6,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 300,
    width: 18,
    height: 4,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 340,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 340,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 340,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 68,
    transform: "translate(-20 386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.781 414.678C134.781 417.795 132.642 420.003 129.094 421.008L128.561 419.996C131.391 419.203 133.141 417.679 133.394 415.744H129.203V414.678H134.781ZM130.652 425.998V421.363H138.664V425.998H130.652ZM131.924 424.959H137.379V422.402H131.924V424.959ZM134.836 418.068V416.988H137.365V413.926H138.664V420.857H137.365V418.068H134.836ZM144.017 416.223C144.017 417.604 144.865 418.978 146.45 419.6L145.753 420.598C144.632 420.146 143.832 419.299 143.395 418.267C142.944 419.415 142.11 420.399 140.927 420.912L140.216 419.914C141.87 419.189 142.759 417.61 142.759 416.223V414.65H144.017V416.223ZM142.39 423.018V421.965H150.716V426.162H149.431V423.018H142.39ZM146.847 421.254V414.131H148.05V417.043H149.486V413.926H150.716V421.322H149.486V418.123H148.05V421.254H146.847Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 454,
    fill: "#222222",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1224_6680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 454,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewTenantList);
export default __webpack_public_path__ + "static/media/preview-tenant-list.3f500ef1d9777b857764e468c4649ea7.svg";
export { ForwardRef as ReactComponent };